import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";


type Props = {

}

export const GenerateLogReajusteContratoFinanceiroColumns = (): GridColDef[] => {

    const computeItemStatusTitle = (status: boolean) => {
        switch (status) {
            case false:
                return "Reajuste Ativo";
            case true:
                return "Contrato Paralisado";
            default:
                return "Nda";
        }
    };

    const computeItemStatusColor = (status: boolean) => {
        switch (status) {
            case false:
                return "green";
            case true:
                return "red";
            default:
                return "blue";
        }
    };

    const computeItemStatusDescription = (status: boolean) => {
        switch (status) {
            case false:
                return "Reajuste Ativo";
            case true:
                return "Contrato Paralisado";
            default:
                return "?";
        }
    };

    const columns: GridColDef[] = [
        {
            field: "idContratoFinanceiro",
            filterable: false,
            headerName: "N° Contrato",
            minWidth: 80,
            width: 80,
            align: "center",
            sortable: false,
        },
        {
            field: "nomeIndiceReajuste",
            filterable: false,
            headerName: "Indice de Reajuste",
            flex: 1,
            minWidth: 150,
            width: 250,
            sortable: false,
        },
        {
            field: "percentualReajuste",
            filterable: false,
            headerName: "Percentual Reajuste",
            minWidth: 100,
            width: 100,
            align: 'center',
            sortable: false,
            renderCell: ({ value }) => (<div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>),
        },
        {
            field: "dataCriacao",
            filterable: false,
            headerName: "Data Cadastro",
            minWidth: 120,
            width: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "dataReajuste",
            filterable: false,
            headerName: "Data Reajuste",
            minWidth: 120,
            width: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "paralisado",
            filterable: false,
            headerName: "Observação",
            flex: 1,
            minWidth: 150,
            width: 150,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },

    ];

    return columns

}